import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

import Fonts from '../fonts';

type Props = {
    promoCode: string | null;
};

const AppointmentPromoSlot = (props: Props) => {
    const { promoCode } = props;

    if (!promoCode) {
        return null;
    }

    return (
        <PromoContainer>
            <Fonts.Body>
                Your promo code
                {' '}
                <PromoCode>{promoCode.toUpperCase()}</PromoCode>
                {' '}
                will be validated after verifying your phone number.
            </Fonts.Body>
        </PromoContainer>
    );
};

export default AppointmentPromoSlot;

const PromoContainer = styled.div`
    display: flex;
    padding: 16px;
    border-radius: 12px;
    background-color: ${colors.PERIWINKLE_4};
    margin-bottom: -16px;
`;

const PromoCode = styled.span`
    font-weight: 600;
`;
